import { getUserSessionStore } from '@zillow/user-session-store-core';

/**
 * Forwards subscribe to global store if it exists.
 * Binds listener with updated state.
 * @param  {Function} listener
 *                      store change callback with nextState as sole argument
 * @return {Function} unsubscriber
 */
function subscribeToUserSessionStore(listener) {
  var store = getUserSessionStore();
  return store.subscribe(function () {
    listener(store.getState());
  });
}

export default subscribeToUserSessionStore;
